import React from "react";

const Search = ({keyenter, clickbtn}) => {
  return (
    <div className="box search">
      <div className="field has-addons">
        <div className="control is-expanded">
          <input
            className="input has-text-centered inputExpand"
            type="search"
            id="searchInput"
            onKeyPress={keyenter}
            placeholder="Search tag (use comma to combined multiple tags)"
          />
        </div>
        <div className="control">
          <span className="button is-info" onClick={clickbtn}>
            <i className="fa fa-search fa" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </div>
  );
};
export default Search;



// WEBPACK FOOTER //
// ./src/components/search.js